import { render, staticRenderFns } from "./payfor-taobao.vue?vue&type=template&id=64799d97&scoped=true&"
import script from "./payfor-taobao.vue?vue&type=script&lang=js&"
export * from "./payfor-taobao.vue?vue&type=script&lang=js&"
import style0 from "./payfor-taobao.vue?vue&type=style&index=0&id=64799d97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64799d97",
  null
  
)

export default component.exports